import axios from "../../config/axiosConfig";
import { CREATE_RIGHTS, GET_RIGHTS, RIGHTS_REQUEST, DELETE_RIGHTS, UPDATE_RIGHTS, RIGHTS_REQUEST_FAILURE, GET_AUTHORIZE_COMPANIES } from "../types";
import { differenceBy } from 'lodash';

export const getRights = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      const { auth } = getState();
      const customer = auth?.customer;
      return axios.get("/right/getAll", { params: { customerId: customer?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RIGHTS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAuthorizeCompanies = (userId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      const { auth } = getState();
      return axios.get("/authorizeCompany/getAll", { params: { userId, customerId: auth?.user?.Customer_Id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_AUTHORIZE_COMPANIES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
    }
  }
}

export const alterAuthorizeCompanies = (data, userId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      const { right: { authorizeCompanies = [] } = {}, auth } = getState();
      const addData = differenceBy(data, authorizeCompanies, 'Company_Id');
      const deleteData = differenceBy(authorizeCompanies, data, 'Company_Id');
      console.log('<<Add data--', addData, ' delete-data--', deleteData);
      if (addData.length) {
        addData.forEach(async (data) => {
          await axios.post("/authorizeCompany/add", data, { params: { userId: auth?.user?.id, customerId: auth?.user?.Customer_Id }});
        });
      }
      if (deleteData.length) {
        deleteData.forEach(async (data) => {
          await axios.delete(`/authorizeCompany/delete/${data.id}`);
        });
      }
      if (userId || data[0]?.User_Id) {
        dispatch(getAuthorizeCompanies(userId || data[0]?.User_Id));
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
    }
  }
}

export const createRight = (rights) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      const { auth } = getState();
      const user = auth?.user || auth?.superUser;
      return axios.post("/right/add", rights, { params: { userId: user?.id, customerId: user?.Customer_Id }}).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_RIGHTS, payload: response.data });
        } else {
          dispatch({
            type: RIGHTS_REQUEST_FAILURE,
            error: "UserRight create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const alterRight = (rights) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      const { auth } = getState();
      const user = auth?.user || auth?.superUser;
      return axios.post("/right/bulkAlter", { data: rights },
        { params: { userId: user?.id, customerId: user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch(getRights());
        } else {
          dispatch({
            type: RIGHTS_REQUEST_FAILURE,
            error: "Rights altered failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateRight = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      const { auth } = getState();
      const user = auth?.user || auth?.superUser;
      return axios.put("/right/update", { id, data }, { params: { userId: user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_RIGHTS,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: RIGHTS_REQUEST_FAILURE,
            error: "Right update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteRight = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: RIGHTS_REQUEST });
      return axios.delete(`/right/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_RIGHTS, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getUserRights = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const user = auth?.user || auth?.superUser;
      return axios.get("/right/getUserRights", { params: { userId: user?.id }}).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RIGHTS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};